import { Link } from 'react-router-dom'
import './Home.css'

function Home() {
  return (
    <div className="home-page">
      {/* ===== HERO LANDING (primero) ===== */}
      <section className="landing-hero" style={{ scrollMarginTop: '100px' }}>
        <div className="hero-main">
          <div className="hero-text-block">
            <h1 className="hero-title">WEDDING PLANNING MADE HUMAN.</h1>
            <div className="hero-wave hero-wave--small" aria-hidden="true">
              <svg viewBox="0 0 200 12" preserveAspectRatio="none">
                <path d="M0 6 Q25 0 50 6 T100 6 T150 6 T200 6" fill="none" stroke="currentColor" strokeWidth="2" />
              </svg>
            </div>
            <p className="hero-description">
              Everything you need to plan, track, and enjoy your wedding, all in one place.
            </p>
            <p className="hero-slogan">(our tools are for free while we launch)</p>
          </div>
          <div className="hero-illustration">
            <img src="/img/AngelConVino.png" alt="Wedding planning" className="hero-img" />
          </div>
        </div>
      </section>

      <section id="home" className="landing-container" style={{ scrollMarginTop: '100px' }}>
        {/* ===== CONTENT SECTION ===== */}
        <div className="landing-content">
          <h1 className="landing-title">Finally, a Wedding Tool That Gets Real</h1>
          <p className="landing-subtitle">Built with real wedding pros, so you can skip the chaos and keep the joy</p>
          <div className="decorative-line"></div>
          
          <div className="landing-text">
            <p>
              <span className="highlight-text">Emails, coffee runs, Netflix binges?</span> Your wedding shouldn't take over everything.
            </p>
            <p>
              We're building tools for straightforward (and sanity-saving) wedding planning. No endless runsheets, no binder explosions, just clarity and flow. <strong>All our core tools are free and live right now</strong> — start planning your wedding today.
            </p>
            <p>
              We get it — weddings are stressful (for you, your partner, and let's be real... even auntie Karen). That's why we have real wedding professionals making sure nothing slips through the cracks.
            </p>
            <p>
              <span className="highlight-text">The Unfiltered Collective.</span> Leave the fire-fighting to us — you've got better things to do (like actually enjoying being engaged).
            </p>
          </div>

          <div className="buttons-container">
            <Link to="/register" className="btn-signup">Sign up to be first</Link>
            <Link to="/about-us" className="btn-magic">How We Make the Magic Happen</Link>
          </div>
        </div>

        {/* ===== ILLUSTRATION SECTION ===== */}
        <div className="landing-illustration">
          <img src="/img/mangera.png" alt="Wedding illustration" className="illustration-img" />
        </div>
      </section>
    </div>
  )
}

export default Home
